export const REDIRECT_SELECT_DATA = {
  INNER: 'Inner redirect',
  OUTER: 'Redirect to another site',
}
export const REDIRECT_SELECT_STATIC = [
  { label: REDIRECT_SELECT_DATA.INNER },
  { label: REDIRECT_SELECT_DATA.OUTER },
]
export const WINDOW_SELECT_DATA = { CURRENT: 'This tab', NEW: 'New tab' }
export const WINDOW_SELECT_STATIC = [
  { label: WINDOW_SELECT_DATA.CURRENT },
  { label: WINDOW_SELECT_DATA.NEW },
]

export const GROUP_NAME_LOV_KEY = 'CORE_WIDGETS_SITE_PAGES_GROUP_NAME_LOV'
